import type { searchForm } from 'shared';

import { isInternationalCity } from './is-international-city';

export enum TravelType {
  INTERNATIONAL = 'I',
  DOMESTIC = 'D',
}

export const getTravelType = (route: searchForm.RouteState) => {
  const isInternational =
    isInternationalCity(route.dep) || isInternationalCity(route.arr);
  return isInternational ? TravelType.INTERNATIONAL : TravelType.DOMESTIC;
};
